import {
  LOGIN_TOOLS,
  LOGIN_TOOLS_FAIL,
  LOGIN_TOOLS_SUCCESS,
  TOOLS_FIELD_CHANGED,
  AUTH_TOOLS_TOKEN_EXPIRY,

  TOOLS_HSA_SALES_FAIL,
  TOOLS_HSA_SALES_SUCCESS,

  TOOLS_HSA_ROUTES_FAIL,
  TOOLS_HSA_ROUTES_SUCCESS,

  TOOLS_HSA_TRANSFER_FAIL,
  TOOLS_HSA_TRANSFER_SUCCESS,

  TOOLS_AUDIT_CLAIMS_FAIL,
  TOOLS_AUDIT_CLAIMS_SUCCESS,

  TOOLS_AUDIT_CLAIM_DETAILS_FAIL,
  TOOLS_AUDIT_CLAIM_DETAILS_SUCCESS,

  TOOLS_AUDIT_CLAIM_DETAILS_PASS_SUCCESS,

  TOOLS_AUDIT_PADS_FAIL,
  TOOLS_AUDIT_PADS_SUCCESS,

  TOOLS_AUDIT_PAD_DETAILS_FAIL,
  TOOLS_AUDIT_PAD_DETAILS_SUCCESS,

  TOOLS_API_TEST_FAIL,
  TOOLS_API_TEST_SUCCESS,

  TOOLS_AD_MANAGE_FAIL,
  TOOLS_AD_MANAGE_SUCCESS,

  TOOLS_AD_LIST_FAIL,
  TOOLS_AD_LIST_SUCCESS,

  TOOLS_UPDATE_ITEM_FAIL,
  TOOLS_UPDATE_ITEM_SUCCESS,

  TOOLS_REMOVE_UPDATE_ITEM_SUCCESS,
  TOOLS_REMOVE_UPDATE_ITEM_FAIL,

  TOOLS_UPDATE_LIST_FAIL,
  TOOLS_UPDATE_LIST_SUCCESS,

  TOOLS_UPDATE_LIST_APPEND_FAIL,
  TOOLS_UPDATE_LIST_APPEND_SUCCESS,

  LOGOUT_TOOLS,
  LOGIN_SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  id: '',
  pw: '',
  username: '',
  permissions: {},
  error: false,
  errors: {},
  loading: false,
  apiTestData: '',
  token: '',
  expiry: '',
  adList: [],
  updateList: [],
  updateListFetchStart: 1,
  updateListFetchLength: 1,
  updateListVersionQuery: ''
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case TOOLS_FIELD_CHANGED:
        return { ...state,
          [action.fieldName]: action.fieldValue
        };
      case LOGIN_TOOLS:
        return { ...state, loading: true, errors: {}, error: false };
      case LOGIN_TOOLS_SUCCESS:
        return {
          ...state,
          id: '',
          pw: '',
          error: false,
          errors: {},
          loading: false,
          permissions: action.permissions,
          username: action.username,
          token: action.token,
          expiry: action.expiry
        };
      case LOGIN_TOOLS_FAIL:
        return { ...state, error: true, errors: action.errors, id: '', pw: '', loading: false };
      case AUTH_TOOLS_TOKEN_EXPIRY:
        return { ...state, expiry: action.expiry}
      case TOOLS_AD_LIST_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_AD_LIST_SUCCESS:
        return { ...state,
          error: false,
          errors: {},
          loading: false,
          adList: action.data.adList,
          adConditions: (action.data.adConditions)? action.data.adConditions : state.adConditions }

      case TOOLS_UPDATE_ITEM_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_REMOVE_UPDATE_ITEM_SUCCESS:
        const afterRemoveItems = Object.values(state.updateList).filter(updateItem => action.data.removeItemId != updateItem.UPDATEID);
        return { ...state,
          error: false,
          errors: {},
          loading: false,
          updateList: afterRemoveItems,
        }
      case TOOLS_REMOVE_UPDATE_ITEM_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_UPDATE_ITEM_SUCCESS:
        const beforeUpdateItems = Object.values(state.updateList).filter(updateItem => action.data.updateItem.UPDATEID != updateItem.UPDATEID);
        return { ...state,
          error: false,
          errors: {},
          loading: false,
          updateList: beforeUpdateItems.concat(action.data.updateItem),
        }
      case TOOLS_UPDATE_LIST_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_UPDATE_LIST_SUCCESS:
        return { ...state,
          error: false,
          errors: {},
          loading: false,
          updateList: action.data.updateItems,
        }
      case TOOLS_UPDATE_LIST_APPEND_SUCCESS:
        const oldItems = Object.values(state.updateList).filter(updateItem => !action.data.updateItems.some(newUpdateItem => newUpdateItem.UPDATEID === updateItem.UPDATEID));
        return { ...state,
          error: false,
          errors: {},
          loading: false,
          updateList: oldItems.concat(action.data.updateItems),
        }
      case TOOLS_HSA_SALES_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_HSA_SALES_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, hsaSales: action.data.sales};
      case TOOLS_HSA_ROUTES_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_HSA_ROUTES_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, hsaRoutes: action.data.routes};
      case TOOLS_HSA_TRANSFER_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_HSA_TRANSFER_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, hsaTransfer: action.data.charges};
      case TOOLS_AUDIT_CLAIMS_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_AUDIT_CLAIMS_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, auditClaims: action.data.auditClaims};
      case TOOLS_AUDIT_CLAIM_DETAILS_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_AUDIT_CLAIM_DETAILS_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, auditClaim: action.data.auditClaim};
      case TOOLS_AUDIT_CLAIM_DETAILS_PASS_SUCCESS:
        if(!state.auditClaims)
          return {...state, error: false, errors: {}, message: action.data.message, loading: false };
        let auditClaims = state.auditClaims.filter((item) => item.CLAIM != action.data.id);
        return { ...state, error: false, errors: {}, loading: false, auditClaims: auditClaims}
      case TOOLS_AUDIT_PADS_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case TOOLS_AUDIT_PADS_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, auditPads: action.data.auditPads};
      case TOOLS_AUDIT_PAD_DETAILS_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, auditPad: {} };
      case TOOLS_AUDIT_PAD_DETAILS_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, auditPad: action.data.auditPad};
      case TOOLS_API_TEST_FAIL:
        return { ...state, error: true, apiTestData: '', errors: action.errors,  loading: false };
      case TOOLS_API_TEST_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, apiTestData: action.data};
      case LOGIN_SUCCESS:
        return { ...state, id: '', pw: '', error: false, errors: {}, loading: false };
      case LOGOUT_TOOLS:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
